module.exports = __webpack_public_path__ + "img/gratitude-journal_B095L76L7B.19a9300b.jpg";